import { render, staticRenderFns } from "./add-remark.vue?vue&type=template&id=5c85de2a&scoped=true&"
import script from "./add-remark.vue?vue&type=script&lang=js&"
export * from "./add-remark.vue?vue&type=script&lang=js&"
import style0 from "./add-remark.vue?vue&type=style&index=0&id=5c85de2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85de2a",
  null
  
)

export default component.exports